<template>
  <b-card>
    <b-row>
      <b-col xl="6">
        <b-form-group
          label="Total"
          label-for="total"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="total"
            v-model.trim= "$v.total.$model" 
            :state="totalValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="totalFeedback">
            {{ totalInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Moneda"
          label-for="moneda"
          :label-cols="2"
          horizontal>
          <b-form-select 
            v-model="monedaNombre" 
            :options="monedasList" 
            class="mb-3">
            <template slot="first">
              <option :value="null" disabled>Seleccione una moneda</option>
            </template>
          </b-form-select>                 
        </b-form-group>

        <b-form-group
          label="Cotización"
          label-for="cotizacion"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="cotizacion"
            v-model.trim= "$v.cotizacion.$model" 
            :state="cotizacionValido"
            type="text"
            @blur.native="validate"
            :readonly="cotizacionReadOnly">
          </b-form-input>
          <b-form-invalid-feedback id="cotizacionFeedback">
            {{ cotizacionInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
        
        <b-form-group
          label="Total $"
          label-for="totalPesos"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="totalPesos"
            :value="totalPesos" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <!-- <b-form-group
          label="Orden $"
          label-for="totalPesos"
          :label-cols="2"
          description="Monto neto de la orden de facturación de logística"
          v-if="montoNetoOrdenFacturacionLogistica != 0"
          horizontal>
          <b-form-input 
            id="montoNetoOrdenFacturacionLogistica"
            :value="montoNetoOrdenFacturacionLogistica | numero(2)" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group> -->
      </b-col>

      <b-col xl="6">
        <b-form-group
          label="Base/Alicuota"
          label-for="baseAlicuota1"
          :label-cols="3"
          horizontal>
          <b-form-input 
            id="montoBase1"
            class="base"
            v-model.trim= "$v.montoBase1.$model" 
            :state="montoBase1Valido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-input 
            id="pjeAlicuota1"
            class="alicuota"
            v-model.trim= "$v.pjeAlicuota1.$model" 
            :state="pjeAlicuota1Valido"
            type="text"
            :readonly="pjeAlicuotaDisabled"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="baseAlicuota1Feedback">
            {{ baseAlicuota1InvalidosMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
              
        <b-form-group
          label="Base/Alicuota"
          label-for="baseAlicuota2"
          :label-cols="3"
          horizontal>
          <b-form-input 
            id="montoBase2"
            class="base"
            v-model.trim= "$v.montoBase2.$model" 
            :state="montoBase2Valido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-input 
            id="pjeAlicuota2"
            class="alicuota"
            v-model.trim= "$v.pjeAlicuota2.$model" 
            :state="pjeAlicuota2Valido"
            type="text"
            :readonly="pjeAlicuotaDisabled"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="baseAlicuota2Feedback">
            {{ baseAlicuota2InvalidosMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Base/Alicuota"
          label-for="baseAlicuota3"
          :label-cols="3"
          horizontal>
          <b-form-input 
            id="montoBase3"
            class="base"
            v-model.trim= "$v.montoBase3.$model" 
            :state="montoBase3Valido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-input 
            class="alicuota"
            id="pjeAlicuota3"
            v-model.trim= "$v.pjeAlicuota3.$model" 
            :state="pjeAlicuota3Valido"
            type="text"
            :readonly="pjeAlicuotaDisabled"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="baseAlicuota3Feedback">
            {{ baseAlicuota3InvalidosMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { decimal, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'compra/getField',
  mutationType: 'compra/updateField',
});

export default {
  name: 'ABM',
  components: {
  },
  props: {
    noValidar: {
      type: Boolean,
      default: false,
    },
    monedas: {
      type: Array,
      default: null
    },
    monedasList: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      cotizacionReadOnly: true,
      
      totalValido: null,
      totalInvalidoMsj: '',
      cotizacionValido: null,
      cotizacionInvalidoMsj: '',
      montoBase1Valido: null,
      pjeAlicuota1Valido: null,
      baseAlicuota1InvalidosMsj: '',
      montoBase2Valido: null,
      pjeAlicuota2Valido: null,
      baseAlicuota2InvalidosMsj: '',
      montoBase3Valido: null,
      pjeAlicuota3Valido: null,
      baseAlicuota3InvalidosMsj: '',
    }
  },
  computed: {
    ...mapFields([
      'moneda',
      'monedaNombre',
      'cotizacion',
      'total', 
      'montoBase1', 
      'pjeAlicuota1',
      'montoBase2',
      'pjeAlicuota2', 
      'montoBase3',
      'pjeAlicuota3',
      'montoNetoOrdenFacturacionLogistica',

      'pjeAlicuotaDisabled'
    ]),
    totalPesos: function () {
      return this.$options.filters.numero(this.total * this.cotizacion, 2, true);
    },
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'total' || validarTodos) {
        this.totalValido = null;
        if (this.$v.total.$error) {
          this.totalValido = false;
          this.totalInvalidoMsj = 'El monto total ingresado no es válido.';
        } else {
          this.totalValido = null;
          this.totalInvalidoMsj = '';
        }
      }

      if (campo == 'montoBase1' || validarTodos) {
        this.montoBase1Valido = null;
        if (this.$v.montoBase1.$error) {
          this.montoBase1Valido = false;
        }
      }
      if (campo == 'pjeAlicuota1' || validarTodos) {
        this.pjeAlicuota1Valido = null;
        if (this.$v.pjeAlicuota1.$error) {
          this.pjeAlicuota1Valido = false;
        }
      }

      if (this.montoBase1Valido == false || this.pjeAlicuota1Valido == false) {
        this.baseAlicuota1InvalidosMsj = 'El monto base y la alícuota ingresados no son válidos.';
      } else {
        this.baseAlicuota1InvalidosMsj = '';
      }

      if (campo == 'montoBase2' || validarTodos) {
        this.montoBase2Valido = null;
        if (this.$v.montoBase2.$error) {
          this.montoBase2Valido = false;
        }
      }
      if (campo == 'pjeAlicuota2' || validarTodos) {
        this.pjeAlicuota2Valido = null;
        if (this.$v.pjeAlicuota2.$error) {
          this.pjeAlicuota2Valido = false;
        }
      }

      if (this.montoBase2Valido == false || this.pjeAlicuota2Valido == false) {
        this.baseAlicuota2InvalidosMsj = 'El monto base y la alícuota ingresados no son válidos.';
      } else {
        this.baseAlicuota2InvalidosMsj = '';
      }

      if (campo == 'montoBase3' || validarTodos) {
        this.montoBase3Valido = null;
        if (this.$v.montoBase3.$error) {
          this.montoBase3Valido = false;
        }
      }
      if (campo == 'pjeAlicuota3' || validarTodos) {
        this.pjeAlicuota3Valido = null;
        if (this.$v.pjeAlicuota3.$error) {
          this.pjeAlicuota3Valido = false;
        }
      }

      if (this.montoBase3Valido == false || this.pjeAlicuota3Valido == false) {
        this.baseAlicuota3InvalidosMsj = 'El monto base y la alícuota ingresados no son válidos.';
      } else {
        this.baseAlicuota3InvalidosMsj = '';
      }
    },
    save() {
      let save = true;

      let moneda;
      if (this.monedaNombre) {
        moneda = this.getSelected(this.monedas, this.monedaNombre);
      }
      this.$store.dispatch('compra/setMoneda', moneda);

      let monedaError = true;
      if (this.moneda) {
        if (this.moneda.id) {
          if (this.moneda.id != 0) {
            monedaError = false;
          }
        }
      }
      if (monedaError) {
        save = false;
        this.monedaValida = false;
        this.monedaInvalidaMsj = "Debe seleccionar la moneda correspondiente.";
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
        save = false;
      }

      return save;
    }
  },
  validations: {
    total: { decimal, minValue: minValue(0) },
    cotizacion: { decimal, minValue: minValue(0) },
    montoBase1: { decimal, minValue: minValue(0) },
    montoBase2: { decimal, minValue: minValue(0) },
    montoBase3: { decimal, minValue: minValue(0) },
    pjeAlicuota1: { decimal, minValue: minValue(0) },
    pjeAlicuota2: { decimal, minValue: minValue(0) },
    pjeAlicuota3: { decimal, minValue: minValue(0) },
  },  
  watch: {
    'monedaNombre' : function(newVal, oldVal) {
      for ( let key in this.monedas ){
        const moneda = this.monedas[key]
        if (moneda.nombre.trim() == newVal.trim() ){
          
          this.$store.dispatch('compra/setMoneda', moneda)
          
          if (moneda.id == 101) {
            this.cotizacionReadOnly = true
            this.cotizacion = 1
          } else {
            this.cotizacionReadOnly = false
          }

          this.monedaValida = null;
          this.monedaInvalidaMsj = '';
        }
      }
    },
    'total' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontosTotal')
    },
    'cotizacion' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontosTotal')
    },
    'montoBase1' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
    'montoBase2' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
    'montoBase3' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
    'pjeAlicuota1' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
    'pjeAlicuota2' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
    'pjeAlicuota3' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontos')
    },
  },
}
</script>

<style>
</style>
